import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { Shield, Clock } from 'lucide-react';

/**
 * Bandeau global affichant les pôles auxquels l'utilisateur a accès.
 * - Admin/super_admin : aucun bandeau (accès total)
 * - Utilisateur sans restriction : aucun bandeau (compatible)
 * - Utilisateur restreint : bandeau bleu avec liste des pôles
 */
const PoleFilterBanner: React.FC = () => {
  const user = useAppSelector(state => state.auth.user);

  if (!user) return null;
  if (user.role === 'super_admin' || user.role === 'admin') return null;

  const polesPermanents = user.poles_autorises || [];
  const accesTemp = (user.poles_acces_temporaire || []).filter(
    a => new Date(a.date_expiration) >= new Date()
  );

  // Aucune restriction
  if (polesPermanents.length === 0 && accesTemp.length === 0) return null;

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border-b border-blue-200 dark:border-blue-800 px-4 py-2">
      <div className="flex items-center gap-2 flex-wrap text-xs">
        <Shield size={13} className="text-blue-600 dark:text-blue-400 shrink-0" />
        <span className="text-blue-700 dark:text-blue-300 font-medium">
          Accès limité aux pôles :
        </span>
        {polesPermanents.map(p => (
          <span
            key={p}
            className="inline-flex items-center px-2 py-0.5 bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-200 rounded-full font-semibold"
          >
            {p}
          </span>
        ))}
        {accesTemp.map(a => (
          <span
            key={a.pole}
            className="inline-flex items-center gap-1 px-2 py-0.5 bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-200 rounded-full font-semibold"
            title={`Accès temporaire jusqu'au ${a.date_expiration}`}
          >
            <Clock size={10} /> {a.pole}
          </span>
        ))}
      </div>
    </div>
  );
};

export default PoleFilterBanner;
